import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SaturnePage from "../../components/SaturnePage/SaturnePage";
import { toPublicUrl } from "../../services/PublicUrl";
import styles from "./Home.module.css";

const Home: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <SaturnePage loading={false} needsLogin={false} wide>
      <div className={styles.home}>
        <section className={styles.hero}>
          <div className={styles.heroContent}>
            <span className={styles.eyebrow}>{t("home.eyebrow")}</span>
            <h1>
              <span>Saturne</span>
              {t("title.home")}
            </h1>
            <p>{t("home.intro")}</p>
          </div>
          <img
            className={`${styles.homeImageIcon} home-image-icon`}
            alt=""
            src={toPublicUrl("/assets/home.jpg")}
          />
        </section>

        <section className={styles.actions} aria-label={t("title.home")}>
          <Link className={styles.actionCard} to="/MySchedules">
            <span className={styles.actionIcon} aria-hidden="true">
              31
            </span>
            <span>
              <strong>{t("home.mySchedules")}</strong>
              <small>{t("home.mySchedulesHint")}</small>
            </span>
            <i aria-hidden="true">→</i>
          </Link>
          <Link className={styles.actionCard} to="/Schedules">
            <span className={styles.actionIcon} aria-hidden="true">
              ⌕
            </span>
            <span>
              <strong>{t("home.directory")}</strong>
              <small>{t("home.directoryHint")}</small>
            </span>
            <i aria-hidden="true">→</i>
          </Link>
        </section>
      </div>
    </SaturnePage>
  );
};

export default Home;
